var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"input-value":_vm.requirement.wip,"label":_vm.$t('requirement.wip')},on:{"change":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }